import * as faceapi from "face-api.js";

export const useFaceRecognition = {
  methods: {
    async recognize() {
      const imageDescriptor = await this.detectFaceOnImage();
      const webcamDescriptor = await this.detectFace(this.$refs.webcam);
      if (imageDescriptor && webcamDescriptor) {
        const dist = faceapi.euclideanDistance(
          webcamDescriptor,
          imageDescriptor
        );
        dist <= 0.55 ? await this.authSuccess() : await this.authFailed();
      }
      if (!this.isSuccess) {
        setTimeout(this.recognize, 250);
      }
    },
    async detectFaceOnImage() {
      const imageUrl = this.user.image_url;
      const img = await faceapi.fetchImage(imageUrl);
      const descriptor = await this.detectFace(img);
      return descriptor;
    },
    async detectFace(faceSource) {
      const options = new faceapi.TinyFaceDetectorOptions();
      const results = await faceapi
        .detectSingleFace(faceSource, options)
        .withFaceLandmarks()
        .withFaceDescriptor();
      if (results) {
        return results.descriptor;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/authorization/mixins/useFaceRecognition.js